import React from "react";

const ExternalLinkButton = ({ options = {} }) => {
  const {
    icon_left,
    icon_right,
    main_btn_heading,
    main_btn_link,
    main_btn_container_classes = "",
    main_btn_classes = "",
  } = options;

  // Sin URL válida, no renderizamos nada
  if (!main_btn_link) return null;

  return (
    <div className={main_btn_container_classes}>
      <a
        href={main_btn_link}
        className={`btn t-border-r05 ${main_btn_classes}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {icon_left?.icon && (
          <i className={`${icon_left.icon} t-mr-05`} aria-hidden="true" />
        )}

        <span>{main_btn_heading}</span>

        {icon_right?.icon && (
          <i className={`${icon_right.icon} t-pl-1`} aria-hidden="true" />
        )}
      </a>
    </div>
  );
};

export default ExternalLinkButton;
